import React, { Component } from "react";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getTheme } from "../../actions/themeActions";

class index extends Component {
  componentDidMount() {
    this.props.getTheme();
  }

  iconDisplay = () => {
    const { theme, type, className } = this.props;

    switch (type) {
      case "world":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
            className={`icon ${theme} ${className}`}
          >
            <path
              id="icon_world"
              d="M102,2A100,100,0,1,0,202,102,100.036,100.036,0,0,0,102,2ZM92,181.3A79.884,79.884,0,0,1,22,102a81.179,81.179,0,0,1,2.1-17.9L72,132v10a20.059,20.059,0,0,0,20,20Zm69-25.4A19.84,19.84,0,0,0,142,142H132V112a10.029,10.029,0,0,0-10-10H62V82H82A10.029,10.029,0,0,0,92,72V52h20a20.059,20.059,0,0,0,20-20V27.9a79.822,79.822,0,0,1,29,128Z"
              transform="translate(-2 -2)"
            />
          </svg>
        );
      case "menu":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="12"
            viewBox="0 0 18 12"
            className={`icon ${theme} ${className}`}
          >
            <path
              id="icon_menu_"
              d="M3,18H21V16H3Zm0-5H21V11H3ZM3,6V8H21V6Z"
              transform="translate(-3 -6)"
            />
          </svg>
        );
      case "close":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            className={`icon ${theme} ${className}`}
          >
            <path
              id="icon_close"
              d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
              transform="translate(-5 -5)"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  render() {
    return <div>{this.iconDisplay()}</div>;
  }
}

index.propTypes = {
  theme: PropTypes.string.isRequired,
  getTheme: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme
});

export default connect(
  mapStateToProps,
  { getTheme }
)(index);
